import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import './navbar.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faCalendarAlt, faChartLine, faInfoCircle, faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

const NavBar = () => {
  const pathname = usePathname();
  return (
    <div className="nav-bar">
      <Link href="/" className={`nav-results${pathname === '/' ? ' is-active' : ''}`}>
        <FontAwesomeIcon icon={faHome} />
        <span>Leaderboard</span>
      </Link>
      <Link href="/schedule" className={`nav-schedule${pathname === '/schedule' ? ' is-active' : ''}`}>
        <FontAwesomeIcon icon={faCalendarAlt} />
        <span>Schedule</span>
      </Link>
      <Link href="/charts" className={`nav-charts${pathname === '/charts' ? ' is-active' : ''}`}>
        <FontAwesomeIcon icon={faChartLine} />
        <span>Charts</span>
      </Link>
      <Link href="/about" className={`nav-about${pathname === '/about' ? ' is-active' : ''}`}>
        <FontAwesomeIcon icon={faInfoCircle} />
        <span>About Us</span>
      </Link>
      <Link href="/faq" className={`nav-faq${pathname === '/faq' ? ' is-active' : ''}`}>
        <FontAwesomeIcon icon={faQuestionCircle} />
        <span>FAQ</span>
      </Link>
    </div>
  );
};

export default NavBar;
